module.exports = __webpack_public_path__ + "static/media/pause.2b51dd87.svg";